<template lang="pug">
  .table-responsive
    LoaderTb(v-show="isLoading")
    .notification(v-if="entradas.length < 1 ")
      strong No hay Registros para esta fecha
    table#listEntradas.table.is-striped.is-fullwidth(v-else)
      thead
        tr
          th.is-size-6 
            | PG
          th.is-size-6 
            | Llenadera
          th.is-size-6 
            | Vol. C.
          th.is-size-6 
            | Masa
          th.is-size-6 
            | Entrada
          th.is-size-6 
            | Inicio
          th.is-size-6 
            | Fin
      tbody
        tr(v-for="ent in entradas" :key="ent.Position")
          td
            span.tag.is-black  
              | {{ ent.id_pg }}
          td {{ ent.llenadera_llenado }}
          td {{ ent.volumen20_llenado }}
          td {{ ent.masaKgs_llenado }}
          td {{ ent.entrada_llenado }}
          td {{ ent.inicioCarga_llenado }}
          td {{ ent.finCarga_llenado }}
</template>

<script>
  import LoaderTb from '../componentes/LoaderTb.vue'
  import sca_irgeServices from '@/services/sca/irge.js'

  export default {
    name: 'TbListCargas',
    components: { LoaderTb },
    props: {
      entradas: {
        type: Array,
        default: []
      },
    },
    watch: {
      isLoading() {
        if (this.isLoading) {
          this.classLoading = 'is-loading'
        } else {
          this.classLoading = ''
        }
      }
    },
    data() {
      return {
        isLoading: false,
        classLoading: ''
      }
    },
    methods: {
      cambiarPertenencia(ent) {
        this.isLoading = true
        console.log(ent)
        let isPem = 0
        let irge_Pem = 0

        // 1 y null === PEMEX
        // 0 === IRGE

        switch (ent.isP) {
          case 0:
            console.log('Is 0')
            isPem = 1
            irge_Pem = 0
            break
          case 1:
            console.log('Is 1')
            isPem = 0
            irge_Pem = 1
            break
          case null:
            console.log('Is null')
            isPem = 0
            irge_Pem = 1
            break
        
          default:
            break
        }

        sca_irgeServices.cambiarIRGE_PEMEX( ent.LoadingBayNumber, ent.FolioPLC, irge_Pem)
          .then((resp) => {
            console.log(resp)
            if (resp.success) {
              sca_irgeServices.setPemTanksTrunks(ent.EntryID, ent.TankTruckID, isPem)
                .then( resp => {
                  if (resp.success) {
                    
                  } else {
                    console.log(resp.respuesta)
                  }
                  this.isLoading = false
                  this.$emit('updateTbListCargas', true)
                })
                .catch( e => {
                  console.log(e)
                  this.isLoading = false
                })
            } else {
              console.log(resp.respuesta)
            }
          })
          .catch((e) => console.log(e))


        
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/componentes/TbListasCargas.vue